'use client';

interface DiagramMetadata {
  id: string;
  name: string;
  elementCount: number;
  relationshipCount: number;
  updatedAt: number;
}

interface RenameDiagramDialogProps {
  diagram: DiagramMetadata;
  value: string;
  onChange: (value: string) => void;
  onSave: (diagramId: string, newName: string) => void;
  onCancel: () => void;
  compact?: boolean;
}

export function RenameDiagramDialog({
  diagram,
  value,
  onChange,
  onSave,
  onCancel,
  compact = false,
}: RenameDiagramDialogProps) {
  const handleSave = () => {
    if (value.trim()) {
      onSave(diagram.id, value.trim());
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && value.trim()) {
      handleSave();
    } else if (e.key === 'Escape') {
      onCancel();
    }
  };

  return (
    <div className="fixed inset-0 bg-black/30 flex items-center justify-center z-50">
      <div className={`bg-background border-2 border-accent rounded-lg ${compact ? 'p-4 w-80' : 'p-6'}`}>
        <h3 className={`font-bold text-foreground ${compact ? 'text-sm mb-3' : 'text-lg mb-4'}`}>
          Rename Diagram
        </h3>
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={handleKeyDown}
          autoFocus
          className={`w-full bg-surface border border-border rounded text-foreground ${
            compact ? 'px-2 py-1 text-sm mb-3' : 'px-3 py-2 mb-4'
          }`}
        />
        <div className="flex gap-2">
          <button
            onClick={handleSave}
            className={`flex-1 bg-accent text-white rounded hover:bg-accent-hover ${
              compact ? 'px-2 py-1 text-xs' : 'px-4 py-2'
            }`}
          >
            Save
          </button>
          <button
            onClick={onCancel}
            className={`bg-surface text-foreground rounded hover:bg-accent-muted ${
              compact ? 'px-2 py-1 text-xs' : 'px-4 py-2'
            }`}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
